import { render, staticRenderFns } from "./firstRank.vue?vue&type=template&id=241233bb&scoped=true&"
import script from "./firstRank.vue?vue&type=script&lang=js&"
export * from "./firstRank.vue?vue&type=script&lang=js&"
import style0 from "./firstRank.vue?vue&type=style&index=0&id=241233bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241233bb",
  null
  
)

export default component.exports